import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/how-are-you-feeling")({
  component: () => <Outlet />,
});
